<template>
  <div class="main_left">
    <div class="top">
      <p class="personIcon">
        <img src="../../assets/telemarketer.png" />
      </p>
      <p>
        <span>{{ username }}</span>
      </p>
      <p>
        <el-button type="primary" plain @click="loginOut" size="small"
          >退出登录</el-button
        >
      </p>
    </div>
    <div class="links">
      <el-menu :default-active="active" @select="goPage">
        <el-menu-item index="1">
          <template slot="title">
            <span class="leftLine"></span>
            <span class="rightTitle">我的订单</span>
          </template>
        </el-menu-item>
        <el-menu-item index="2">
          <template slot="title">
            <span class="leftLine"></span>
            <span class="rightTitle">我的资料</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3">
          <template slot="title">
            <span class="leftLine"></span>
            <span class="rightTitle">开票信息</span>
          </template>
        </el-menu-item>
      <div class="qr-block">
        <p class="qr-text">
          工作日16点前成功支付电子担保保函订单的，当天审核出函，若未及时出函可致电客服
        </p>
        <p class="qr-text">
          {{ platformPrefix + '审核客服电话' }}：<br/>4006166620转3
        </p>
        <p class="qr-text" v-if="!isBsgzw">
          保函咨询人员微信如下
          <img :src="this.$cdn.kefu" />
        </p>
      </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'leftAslide',
  props: ['activeNum'],
  data() {
    return {
      active: '1',
    }
  },
  computed: {
    ...mapState({
      username: (state) => state.user.name,
      isBsgzw: (state) => state.letter.isBsgzw,
    }),
    platformPrefix() {
      if (this.isBsgzw) return ''
      return '招采金服'
    },
  },
  created() {
    this.active = this.activeNum
  },
  methods: {
    goPage(active) {
      this.active = active
      if (active === '1') {
        this.$router.push('/orderListIndex')
      } else if (active === '2') {
        this.$router.push('/personalInfo')
      } else {
        this.$router.push('/invoiceIndex')
      }
    },
    loginOut() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store
            .dispatch('user/logout')
            .then(() => {
              this.$router.push('/')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
.box() {
  padding: 20px 10px;
  background-color: white;
}

.main_left {
  margin-right: 10px;
  width: 170px;
  text-align: center;
  .top {
    .box();
    margin-bottom: 20px;
    p {
      margin-bottom: 10px;
    }
  }
  .links {
    .box();
    min-height: 300px;
  }
}
.personIcon {
  img {
    width: 80px;
    height: 80px;
  }
}
.el-menu {
  border-right: none;
}
.el-menu-item .leftLine {
  width: 6px;
  height: 20px;
  background-color: #ffffff;
  display: inline-block;
}
.el-menu-item.is-active .leftLine {
  width: 6px;
  height: 20px;
  background-color: #3b85f4;
  display: inline-block;
}
.rightTitle {
  margin-left: 10px;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: transparent;
}
.qr-block {
  margin-top: 20px;
  text-align: center;
}
.qr-block img {
  margin-top: 20px;
  width: 80px;
  height: 80px;
}
.qr-text {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 25px;
}
</style>
